import { GetterTree } from 'vuex';

// Shared types
import { Map, RequestSpace } from '@coldtec/cos-types';

// Store and store types
import Store from '@/store';
import { RootState, SpacesGetter, ToolSpace } from '@/store/store.types';

/**
 *  Holding every getter of the spaces.
 */
export const Getters: GetterTree<RootState, RootState> = {

    /**
     *  Used to get the added spaces.
     */
    [SpacesGetter.ADDED](state: RootState): Map<ToolSpace> {

        return state.spaces.added;

    },

    /**
     *  Used to get the amount of added spaces.
     */
    [SpacesGetter.COUNT_ADDED](state: RootState): number {

        return Object.keys(state.spaces.added).length;

    },

    /**
     *
     *  Used to get the amount of valid spaces.
     *
     *  (i) Ensuring a system, indoor unit and color has been set
     *
     */
    [SpacesGetter.COUNT_VALID](): number {

        /**
         *  Get every added tool space.
         */
        const spaces = Object.values<ToolSpace>(Store.getters[SpacesGetter.ADDED]) as Array<ToolSpace>;

        /**
         *  The following properties must be set
         *  in order for a space to be valid.
         */
        const requiredProps: Array<keyof RequestSpace> = [
            'system',
            'indoor_unit',
            'color',
        ];

        /**
         *  Subtract the spaces that are invalid from the valid count.
         */
        let valid = spaces.length;

        for (const space of spaces) {

            for (const prop of requiredProps) {

                /**
                 *  The values to check are always a string or null
                 */
                const value = space.data[prop] as string | null;

                /**
                 *  It's invalid if no value or empty string is set.
                 */
                if (!value || !value.length) {

                    valid--;

                    break;

                }

            }

        }

        return valid;

    },

};
